import React from 'react';
import FooterLessLayout from '../../components/Layout/FooterLessLayout';
import Search from './Search';
import fetch from '../../core/fetch';
import { searchListing } from '../../actions/searchListing';
import { trackPageView } from '../../core/analytics';
import { formValueSelector } from 'redux-form';

const title = 'Search';
let queryOld;

export default {
  path: '/s',

  async action(args) {
    const { params, store, query } = args;

    queryOld = query;
    if (!queryOld) {
      trackPageView('/s');
    }

    // From Redux Store
    const geographyData = store.getState().personalized.geography;
    const startDateData = store.getState().personalized.startDate;
    const endDateData = store.getState().personalized.endDate;
    let lat = store.getState().personalized.lat;
    let lng = store.getState().personalized.lng;
    let personCapacity,
      dates,
      categories,
      kw,
      geography,
      geoType,
      minimumRating,
      priceRange,
      location,
      currentPage = 1;
    const initialFilter = {};

    // Geography Data
    if (geographyData != undefined && geographyData != null) {
      geography = geographyData;
    } else if ('lat' in query && query.lat && 'lng' in query && query.lng) {
      lat = query.lat;
      lng = query.lng;
      initialFilter.lat = lat;
      initialFilter.lng = lng;
    } else if ('address' in query && query.address) {
      const latAndLngQuery = `
            query ($address: String) {
              GetAddressComponents (address:$address) {
                addressComponents
                lat
                lng
                geoType
              }
            }
          `;
      const locationResp = await fetch('/graphql', {
        method: 'post',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          query: latAndLngQuery,
          variables: { address: query.address },
        }),
        credentials: 'include',
      });

      const { ldata } = await locationResp.json();
      initialFilter.address = query.address;
      initialFilter.geography = ldata.GetAddressComponents.addressComponents;
      initialFilter.lat = ldata.GetAddressComponents.lat;
      initialFilter.lng = ldata.GetAddressComponents.lng;
      geography = ldata.GetAddressComponents.addressComponents;
      geoType = ldata.GetAddressComponents.geoType;
      lat = ldata.GetAddressComponents.lat;
      lng = ldata.GetAddressComponents.lng;
    }

    // http://localhost:3001/s?&minRating=4&priceMin=22&priceMax=44
    if (
      startDateData != undefined &&
      startDateData != null &&
      endDateData != undefined &&
      endDateData != null
    ) {
      dates = `'${startDateData}' AND '${endDateData}'`;
    } else if (
      'startDate' in query &&
      'endDate' in query &&
      query.startDate &&
      query.endDate
    ) {
      initialFilter.startDate = query.startDate;
      initialFilter.endDate = query.endDate;
      dates = `'${query.startDate}' AND '${query.endDate}'`;
    }
    if (query.dates) {
      dates = query.dates;
      initialFilter.dates = dates;
    }

    if (query.minRating) {
      initialFilter.minimumRating = query.minRating;
      minimumRating = query.minRating;
    }

    if (query.currentPage) {
      currentPage = query.currentPage;
    }

    if (query.priceMin || query.priceMax) {
      const pRange = [
        query.priceMin ? query.priceMin : 0,
        query.priceMax ? query.priceMax : 1000000,
      ];
      initialFilter.priceRange = pRange;
      priceRange = pRange;
    }

    if ('category' in query && query.category) {
      if (Array.isArray(query.category)) {
        // array
        categories = query.category.map(x => {
          const parsed = parseInt(x);
          if (isNaN(parsed)) {
            console.log('Invalid search category parameters', query.category);
            return [];
          }
          return parsed;
        });
      } else {
        // single value
        const parsed = parseInt(query.category);
        categories = [parsed];
      }
      initialFilter.roomTypes = categories;
    }

    if ('kw' in query && query.kw) {
      kw = query.kw;
      initialFilter.kw = kw;
    }
    if ('keyword' in query && query.keyword) {
      kw = query.keyword;
      initialFilter.kw = kw;
    }

    if ('location' in query && query.location) {
      location = query.location;
    }

    const selector = formValueSelector('SearchForm');
    const searchByMap = selector(store.getState(), 'searchByMap');
    const ne_lat = selector(store.getState(), 'ne_lat');
    const sw_lat = selector(store.getState(), 'sw_lat');
    const ne_lng = selector(store.getState(), 'ne_lng');
    const sw_lng = selector(store.getState(), 'sw_lng');

    await store.dispatch(
      searchListing({
        dates,
        geography,
        geoType,
        currentPage,
        categories,
        kw,
        lat,
        lng,
        minimumRating,
        priceRange,
        location,
        searchByMap,
        ne_lat,
        sw_lat,
        ne_lng,
        sw_lng,
      }),
    );

    return {
      title,
      component: (
        <FooterLessLayout hideSearch>
          <Search initialFilter={initialFilter} query={query} />
        </FooterLessLayout>
      ),
    };
  },
};



// WEBPACK FOOTER //
// ./src/routes/search/index.js